import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import ProfileAvatar from 'components/lib/profile_avatar';
import RelativeDateTime from 'components/lib/date/relative_date_time';
import SafeHtml from 'components/common/safe_html';

export const StyledAvatar = styled(ProfileAvatar)`
  height: 35px;
  width: 35px;
`;

const StyledName = styled.div`
  font-weight: 600;
`;

const StyledCommentDetail = styled.div`
  margin-left: ${p => p.theme.spacing.medium};
`;

const StyledNameRow = styled.div`
  display: flex;
`;

const StyledDate = styled(RelativeDateTime)`
  color: ${p => p.theme.colors.gray600};
  display: none;
  margin-left: 8px;
`;

export const StyledMessage = styled(SafeHtml)`
  word-break: break-word;
`;

const StyledComment = styled.div`
  display: flex;
  margin: ${p => p.theme.spacing.medium} 0px;
  &:hover {
    ${StyledDate} {
      display: block;
    }
  }
`;

export function TaskComment({ agentName, agentAvatarUrl, className, message, createdAt }) {
  function renderAvatar() {
    return (
      <StyledAvatar data-aid="taskComment-avatar" noWrapper profile={{ name: agentName, image: agentAvatarUrl }} />
    );
  }

  function renderDetail() {
    return (
      <StyledCommentDetail data-aid="taskComment-detail">
        <StyledNameRow>
          <StyledName data-aid="taskComment-content-name">{agentName || 'Agent'}</StyledName>
          <StyledDate data-aid="taskComment-content-timestamp" timestamp={createdAt} />
        </StyledNameRow>
        <StyledMessage data-aid="taskComment-content-message" html={message} />
      </StyledCommentDetail>
    );
  }

  return (
    <StyledComment className={className}>
      {renderAvatar()}
      {renderDetail()}
    </StyledComment>
  );
}

TaskComment.propTypes = {
  agentAvatarUrl: PropTypes.string,
  agentName: PropTypes.string,
  className: PropTypes.string,
  createdAt: PropTypes.string,
  message: PropTypes.string,
};

function mapStateToProps({ getProvider }, { initiatingAgentId }) {
  const agentsProvider = getProvider('agents');
  const agent = agentsProvider.findBy({ id: initiatingAgentId });
  if (!agent) return {};

  return {
    agentName: agent.getDisplayName(),
    agentAvatarUrl: agent.avatarUrl,
  };
}

const TaskCommentContainer = connect(mapStateToProps)(TaskComment);

TaskCommentContainer.propTypes = {
  initiatingAgentId: PropTypes.string.isRequired,
};

export default TaskCommentContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/task_comments/task_comment.jsx